/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from '@fluentui/react';

export const messageStyles = (theme: Theme): Record<string, any> => ({
  remoteMessage: {
    root: {
      background: theme.palette.white,
      padding: '0.75rem',
      borderRadius: theme.effects.roundedCorner6,
      width: '85%',
      boxShadow: theme.effects.elevation8,
    },
  },
  userMessage: {
    root: {
      float: 'right',
      background: theme.palette.themePrimary,
      padding: '0.75rem 1rem',
      borderRadius: theme.effects.roundedCorner6,
      width: 'auto',
      maxWidth: '80%',
      boxShadow: theme.effects.elevation8,
    },
  },
  remoteText: {
    textAlign: 'left',
    color: theme.palette.black,
    margin: 0,
    fontSize: theme.fonts.medium.fontSize,
    wordBreak: 'break-word',
  },
  userText: {
    textAlign: 'center',
    margin: 0,
    color: 'black',
    fontSize: theme.fonts.medium.fontSize,
  },
});
